import {put, takeLatest} from 'redux-saga/effects';
import {
    UPDATE_VENUE_STATUSES_WITH_FIREBASE,
    UPDATE_VENUE_STATUSES_WITH_FIREBASE_SUCCESS,
    UPDATE_VENUE_STATUSES_WITH_FIREBASE_ERROR,
}
    from "../../actions/venue";

function* updateVenueStatusesWithFirebaseSaga(action) {
    try {
       yield put({
        type: UPDATE_VENUE_STATUSES_WITH_FIREBASE_SUCCESS,
        payload: action.payload
    });


    } catch (error) {
        yield put({
            type: UPDATE_VENUE_STATUSES_WITH_FIREBASE_ERROR,error: error.data
        });
    }
}


export function* updateVenueStatusesWithFirebaseSagaWatcher() {
    yield takeLatest(UPDATE_VENUE_STATUSES_WITH_FIREBASE, updateVenueStatusesWithFirebaseSaga);
}